import AssetDocuments from "./AssetDocuments";

export default function EquipmentDocuments({ equipmentId }) {
  return <AssetDocuments ownerId={equipmentId} ownerType="EQUIPMENT" />;
}
